<template>
  <div
    :class="[
      'trust-score',
      scoreThreshold,
      size,
      { neutral: neutral, 'dark-mode': darkMode },
    ]"
  >
    <span>{{ score }}</span>
  </div>
</template>

<script>
import { trustScoreRank } from '@/utils/trustScoreRank';

export const TrustScoreDisplaySizes = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

export default {
  props: {
    score: {
      type: Number,
      default: undefined,
    },
    size: {
      type: String,
      default: 'medium',
    },
    neutral: {
      type: Boolean,
      default: false,
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    scoreThreshold() {
      return trustScoreRank(this.score);
    },
  },
};
</script>

<style lang="scss" scoped>
.trust-score {
  border: 1px solid $light-neutral-30;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $light-neutral-120;
  font-weight: 600;
  font-size: $font-size-large;
  position: relative;
  flex-shrink: 0;
  background: $light-neutral-30;

  &.dark-mode {
    background: $light-neutral-90;
    color: $light-neutral-default;

    &.low:not(.neutral) {
      background-color: $light-error-90;
      color: $light-neutral-default;
    }

    &.high:not(.neutral) {
      background-color: $light-success-90;
      color: $light-neutral-default;
    }
  }

  &.neutral {
    background: $light-neutral-default;
  }

  &.medium {
    width: 36px;
    height: 36px;
    font-size: $font-size-small;
  }

  &.large {
    width: 48px;
    height: 48px;
    font-size: $font-size-large;
  }

  .star {
    display: none;
    width: 16px;
    height: 16px;
    background: #0aa386;
    border-radius: 50%;
    color: $color-white;
    position: absolute;
    font-size: calc($font-size-default / 2);
    line-height: $font-size-default + 1;
    top: 32px;
    left: 32px;
    text-align: center;
  }

  &.low:not(.neutral) {
    border: 1px solid transparent;
    background-color: $light-error-30;
    color: $light-error-120;
  }

  &.high:not(.neutral) {
    border: 1px solid transparent;
    background-color: $light-success-30;
    color: $light-success-120;
  }
}
</style>
